import jBox from 'jbox';
import 'jbox/dist/jBox.all.css';

jQuery(document).ready(function () {

    if(jQuery('.about__facts-and-stats__facts').length > 0) {
        new jBox('Tooltip', {
            attach: '.tooltip',
            closeOnMouseleave: true,
            onOpen: function () {
                loadJaotama();
            },
            position: {
                x: 'right',
                y: 'center'
            },
            // offset: {
            //     x: 16
            // },
            outside: 'x'
         });

        jQuery('.tooltip_left').jBox('Tooltip', {
            pointer: 'left:15' // The pointer is moved to the right with a 15 pixel offset
        });
    }

    if(jQuery('.single, .single-recipe').length > 0) {

        // Prefer right of the trigger; fall back to left, then below/above so the
        // share panel never clips off-screen on narrow viewports.
        function placeShareTooltip(jbox) {
            if (!jbox.source || !jbox.source[0]) {
                return;
            }

            var rect = jbox.source[0].getBoundingClientRect();
            var menuWidth = 240;
            var menuHeight = 300;
            var gap = 16;
            var spaceRight = window.innerWidth - rect.right - gap;
            var spaceLeft = rect.left - gap;
            var spaceBottom = window.innerHeight - rect.bottom - gap;
            var spaceTop = rect.top - gap;

            var position;
            var outside;

            if (spaceRight >= menuWidth) {
                position = { x: 'right', y: 'center' };
                outside = 'x';
            } else if (spaceLeft >= menuWidth) {
                position = { x: 'left', y: 'center' };
                outside = 'x';
            } else if (spaceBottom >= menuHeight || spaceBottom >= spaceTop) {
                position = { x: 'center', y: 'bottom' };
                outside = 'y';
            } else {
                position = { x: 'center', y: 'top' };
                outside = 'y';
            }

            jbox.options.position = position;
            jbox.options.outside = outside;
            jbox.outside = position[outside];

            if (jbox.pointer && jbox.wrapper) {
                var pointerPos = jbox._getOpp(jbox.outside);
                jbox.pointer.position = pointerPos;
                jbox.pointer.xy = jbox._getXY(pointerPos);
                jbox.pointer.element.attr('class', 'jBox-pointer jBox-pointer-' + pointerPos);
                jbox.pointer.dimensions = {
                    x: jbox.pointer.element.outerWidth(),
                    y: jbox.pointer.element.outerHeight()
                };
                jbox.wrapper
                    .css('padding', 0)
                    .css('padding-' + pointerPos, jbox.pointer.dimensions[jbox.pointer.xy])
                    .removeClass(function (i, className) {
                        return (className.match(/(^|\s)jBox-pointerPosition-\S+/g) || []).join('');
                    })
                    .addClass('jBox-pointerPosition-' + pointerPos);
            }
        }

        new jBox('Tooltip', {
            attach: '.tooltip',
            closeOnMouseleave: true,
            closeOnClick: 'body',
            trigger: 'click',
            adjustPosition: true,
            adjustTracker: true,
            adjustDistance: 16,
            responsiveWidth: false,
            reposition: true,
            repositionOnOpen: true,
            onOpen: function () {
                placeShareTooltip(this);
                loadJaotama();
            },
            position: {
                x: 'right',
                y: 'center'
            },
            outside: 'x'
         });

        jQuery('#tooltip_left').jBox('Tooltip', {
            pointer: 'left:15' // The pointer is moved to the right with a 15 pixel offset
        });

        jQuery('#tooltip_right').jBox('Tooltip', {
            pointer: 'right:15', // The pointer is moved to the right with a 15 pixel offset
            offset: {
                y: -10
            }
        });

    }

    if (jQuery('.fp__hero .statistic-card__tooltip, .asset .stats-card__tooltip, .region .stats-card__tooltip').length > 0) {

        new jBox('Tooltip', {
            attach: '.fp__hero .statistic-card__tooltip, .asset .stats-card__tooltip, .region .stats-card__tooltip',
            closeOnEsc: true,
            closeOnMouseleave: true,
            position: {
                x: 'center',
                y: 'top'
            },
            outside: 'y',
            pointer: true
        });

        // jBox doesn't handle keyboard accessibility on its own, so mirror the
        // mouse behaviour for focus and make the tooltip dismissible (WCAG 1.4.13).
        jQuery('.fp__hero .statistic-card__tooltip, .asset .stats-card__tooltip, .region .stats-card__tooltip')
            .on('focus', function () {
                jQuery(this).trigger('mouseenter');
            })
            .on('blur', function () {
                jQuery(this).trigger('mouseleave');
            })
            .on('keydown', function (e) {
                if (e.key === 'Escape' || e.key === 'Esc') {
                    jQuery(this).trigger('mouseleave');
                }
            });
    }

    function loadJaotama(){

        var links = document.querySelectorAll(window.jaotama_window_opener_class);
        var _a = links;

        var _f = function _f(link) {
            return link.addEventListener('click', openShareDialog);
        };

        for (var _i = 0; _i < _a.length; _i++) {
            _f(_a[_i], _i, _a);
        }

        undefined;

        function openShareDialog(e) {

            e.preventDefault();

            var url = this.getAttribute('href'),
                width = 600,
                height = 300,
                top = window.top.outerHeight / 2 + window.top.screenY - height / 2,
                left = window.top.outerWidth / 2 + window.top.screenX - width / 2;

            if(e.target.parentElement.parentElement.parentElement.classList.contains('copylink') ||  e.target.parentElement.parentElement.classList.contains('copylink')  || e.target.parentElement.classList.contains('copylink') ||  e.target.classList.contains('copylink')){
                navigator.clipboard.writeText(url)
            }else{
                window.open(url, '', 'width=' + width + ', height=' + height + ', top=' + top + ', left=' + left);
                // console.log('this shhould not happen');
            }

        }

        jQuery('.news__share a').each(function(index) {
            jQuery(this).attr('tabindex', 1);
        });


        // Move focus to the first <a> element
        // jQuery('.news__share a:first').focus();
        jQuery('.news__share li').on('keydown', function(e) {
            // Check if the Tab key was pressed
            if (e.key === 'Tab') {
            // If Shift + Tab is pressed, we move focus backward
            if (e.shiftKey && jQuery(this).is(':first-of-type')) {
                // Prevent the default behavior of tabbing out of the element
                e.preventDefault();
                // Move focus to the .single-social.tooltip button
                jQuery('.single-social.tooltip button').focus();
                // console.log('shift tab');
            } else if (!e.shiftKey && jQuery(this).is(':last-of-type')) {
                // Prevent the default behavior of tabbing out of the element
                e.preventDefault();
                // Move focus to the .single-social.tooltip button
                jQuery('.single-social.tooltip button').focus();
                // console.log('tab', jQuery(this).is(':last-of-type'));
            }
            } else if (e.key === 'Escape') {
                // Move focus to the .single-social.tooltip button
                jQuery('.single-social.tooltip button').focus();
                // console.log('escape');
                // Trigger the Enter key press event
                jQuery('.single-social.tooltip button').trigger('click');
            }
        });

        jQuery('.single-social.tooltip').on('keydown', function(e) {
            // console.log('keydown on button', e.key);
            if (e.key === 'Tab' && !e.shiftKey) {
                
                if ((jQuery('.jBox-pointerPosition-right').length > 0 && jQuery('.jBox-pointerPosition-right').css('display') !== 'none') || (jQuery('.jBox-pointerPosition-left').length > 0 && jQuery('.jBox-pointerPosition-left').css('display') !== 'none')) {
                    e.preventDefault();
                    console.log('tab on button', jQuery('.jBox-pointerPosition-left').css('display') !== 'none');
                    jQuery('.news__share a:first').focus();
                }
            }
        });

    }


    jQuery(".jaotama__window-opener.copylink").click(function(event){
        var $copiedElement = jQuery("<span>");
        $copiedElement.addClass('copied-link').text('Copied!');
        jQuery('.jaotama__window-opener.copylink').append($copiedElement);
        $copiedElement.fadeIn(300);
        $copiedElement.fadeOut(1500);

   });

    // Site-wide floating share widget: toggle the panel open/closed.
    var shareSocial = document.querySelector('[data-share-social]');

    if (shareSocial) {

        var shareToggle = shareSocial.querySelector('[data-share-social-toggle]');
        var sharePanel  = shareSocial.querySelector('[data-share-social-panel]');

        var getPanelFocusable = function () {
            if (!sharePanel) {
                return [];
            }
            return Array.prototype.slice.call(
                sharePanel.querySelectorAll('a[href], button, [tabindex]:not([tabindex="-1"])')
            ).filter(function (el) {
                return !el.hasAttribute('disabled') && el.offsetParent !== null;
            });
        };

        var setShareOpen = function (open) {
            shareSocial.classList.toggle('is-open', open);
            shareToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
            if (sharePanel) {
                if (open) {
                    sharePanel.removeAttribute('hidden');
                } else {
                    sharePanel.setAttribute('hidden', '');
                }
            }
            if (open) {
                // Move focus into the panel so keyboard users land inside it.
                var focusable = getPanelFocusable();
                if (focusable.length) {
                    focusable[0].focus();
                }
            }
        };

        shareToggle.addEventListener('click', function (e) {
            e.preventDefault();
            setShareOpen(!shareSocial.classList.contains('is-open'));
        });

        // Close when clicking outside the widget.
        document.addEventListener('click', function (e) {
            if (shareSocial.classList.contains('is-open') && !shareSocial.contains(e.target)) {
                setShareOpen(false);
            }
        });

        // Keyboard handling while the panel is open: Escape closes it and Tab is
        // trapped inside the panel so focus can't leak back to the page.
        shareSocial.addEventListener('keydown', function (e) {

            if (!shareSocial.classList.contains('is-open')) {
                return;
            }

            if (e.key === 'Escape') {
                setShareOpen(false);
                shareToggle.focus();
                return;
            }

            if (e.key === 'Tab') {
                var focusable = getPanelFocusable();
                if (!focusable.length) {
                    return;
                }

                var first = focusable[0];
                var last  = focusable[focusable.length - 1];
                var active = document.activeElement;

                if (e.shiftKey) {
                    if (active === first || !sharePanel.contains(active)) {
                        e.preventDefault();
                        last.focus();
                    }
                } else {
                    if (active === last || !sharePanel.contains(active)) {
                        e.preventDefault();
                        first.focus();
                    }
                }
            }
        });
    }

});
